import axios from "../../plugins/axios";
import utils from "../../../utils/utils";

class Compute {

    //------------采购订单计算申请头相关--------------------//
    //INTF-00272：对创建的计算申请头进行提交
    submitPoComputeRequest(vale) {
        let body = vale;
        return axios.post(`/myMaterialApp/service.MaterialProvider/Calculate`, body);
    }

    //INTF-00274：取消一个计算中的计算请求
    cancelPoComputeRequest(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.MaterialProvider/CancelOneCalculateResult`, body);
    }

    //INTF-00275：分页查询获取计算任务头列表
    async getPoComputeHeaderList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myMaterialApp/service.MaterialProvider/FindAllCalculateJobs`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.material_calculate_job_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get po compute header list in pages failed: INTF-00275", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00280：根据ID查看计算请求设置的信息详情
    getPoComputeRequestDetail(id) {
        let body = { id: id };
        return axios.post(`/myMaterialApp/service.MaterialProvider/DownLoadOneCalculateResult`, body);
    }

    //----------------采购订单计算结果列表相关---------------------//
    //INTF-00273：分页查询获取计算结果列表
    getPoComputeResultList(query, route) {
        let body = { types: "object,object", values: [query, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }





}


export default Compute;